module.exports = __webpack_public_path__ + "static/media/loadingSmall.b2289a36.svg";